export default "__VITE_ASSET__Da9UcoK2__"